import { render, staticRenderFns } from "./ProfileUserDetails.vue?vue&type=template&id=118563d2&"
import script from "./ProfileUserDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports